import styled, { css } from 'styled-components';
import { CreateEventButton } from '../MainEvents/styles';
const MediumFont = 'Rubik-Medium';
const Layout = styled.div`
  width: 100%;
  display: flex;
  .float {
    width; 100%;
    float; left;
  }
>div:first-child{
  width: 67.1%;
}
> div: last-child {
  width: 32.9%;
  padding-left: 25px;
}
  @media (max-width: 500px) {
    padding: 0 10px 30px;
  }
`;

const Title = styled.p`
  font-size: 12px;
  color: ${({ color }) => color ? color : '#159fc9'};
  margin-bottom: 0;
  text-transform: ${({ mainTitle }) => mainTitle ? 'uppercase' : 'none'};
  line-height: 20px;
  text-align: ${({ center }) => center && 'center'};
`;

const AdventureTitle = styled.div`
  font-size: 18px;
  letter-spacing: 0px;
  color: rgb(51,51,51);
  text-align: left;
  text-align: ${({ center }) => center && 'center'};
`;

const ArticleSection = styled.div`
  padding: 0px 0px 25px 0px;
  float: left;
  width: 100%;

  @media (max-width: 500px) {
    padding: 10px 10px 45px;
    margin-top: 10px;
  }
`;

const Description = styled.div`
  padding: ${({ padding }) => padding ? '0px' : '0 15px'};
  text-align: ${({ textAlign }) => textAlign ? 'left' : 'justify'};
  word-break: break-word;
  font-family: Rubik;
  p{
    strong{
     font-family: ${MediumFont};
   }
  }
  table{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  ${'' /* ol{
    list-style-position: inside;
    list-style-type: decimal;
  }
  ul{
    list-style-position: inside;
    list-style-type: dot;
  } */}
`;

const Button = styled.button`
  border: ${({ color }) => color ? '1px solid #9FC989' : '1px solid #DA6C74'};
  color: white;
  white-space: nowrap;
  padding: 16px 20px;
  color: #FEFEFE;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
border-radius: 6px;

  min-width: 200px;
  display: flex;
  justify-content:center;
  align-items:center;
  background-color: ${({ color }) => color ? color : '#DA6C74'};
  ${({ disabled }) => disabled === true && css`
  ${'' /* opacity: 0.5; */}
  cursor: not-allowed !important;
`}
  >img{
    display: flex;
    margin: auto;
    width: 23px;
    height: 23px;
    margin-right: 10px;
  }

  > i {
    color: white;
    margin-left: 12px;
  }

  &:hover, &:active, &:focus {
    outline: none;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  text-align: right;
  margin-top: 35px;
  ${'' /* float: left; */}
  display: flex;
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 524px;
  > div {
    > img {
      width: 100% !important;
      height: 100% !important;
      border-radius: 6px;
    }
  }
  @media (max-width: 767px) and (min-width: 501px) {
    height: 300px;
  }

  @media (max-width: 500px) {
    height: 250px;
  }
`;

const TitleContainer = styled.div`
  display: inline-block;
  float: ${({ float }) => float ? '' : 'left'};
  width: 100%;
  >div:first-child{
    display: flex;
    background: linear-gradient(rgb(82, 168, 237) 0%, rgb(138, 211, 247) 100%);
    border-radius: 6px;
    height: 50px;
    >div{
      width: 50px;
      background: white;
      display: flex;
      height: 50px;
      border-radius: 6px;
    >img{
       width: 32px;
       height: 32px;
       display: flex;
       margin: auto;
    }}
    >span{
      display: flex;
      margin: auto;
      margin-left: 10px;
      text-transform: capitalize;
    font-family: Rubik-Medium;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: white;
    }
  }
  >div:last-child{
    display: flex;
    padding: 15px 0px;
    >div:first-child{
      width: 80%;
      text-transform: capitalize;
    font-family: Rubik-Medium;
    font-weight: 500;
    font-size: 20px;
    color: #0D4270;
    }
    >div:last-child{
      width: 20%;
      display: flex;
      justify-content: flex-end;
      >img{
        width:20px;
        height: 30px;
      }
    }
  }

  @media (max-width: 500px) {
    margin-bottom: 10px;
  }
`;

const EditButton = styled(CreateEventButton)`
  font-size: 12px;
  padding: 0 20px;
  height: 29px;
  margin-left: 10px;

  @media(max-width: 900px) {
    margin-top: ${({ marginTop }) => marginTop && marginTop};
  }
  
  ${({ createButton }) => createButton && css`
    margin: 20px 25px 0 0;
    
    @media (max-width: 500px) {
      margin: 0 auto 20px;
      float: unset;
      display: flex;
    }
  `}
`;

const Float = styled.div`
  width: 100%;
  float: left;
`;

const ImageContainerIcons = styled.div`
  width: 100%;
  margin-bottom: 25px;
  margin-bottom: ${({ margin }) => margin ? '0px' : '25px'};
  display: flex;
  padding: ${({ padding }) => padding ? '15px' : '0 15px'};
  background: white;
  border-radius: 0 0 6px 6px;
  height: 60px;
  >div:first-child{
    width: 50%;
    display: flex;
    >div:first-child{
      display: flex;
      justify-content: flex-start;
      margin-right: 15px;
      >img{
        height: 30px;
        width: auto;
        margin: auto;
      }
      >span{
        font-size: 16px;
        font-family: rubik;
        margin: auto;
        margin-left: 15px;
        text-align: center;
        font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 12px;
color: #3A3A3A;
      }
    }    
    >div:nth-child(2){
      display: flex;
      margin-right: 15px;
      >img{
        width: auto;
        height: 30px;
        margin: auto;
      }
      >span{
        font-size: 16px;
        font-family: rubik;
        text-align: center;
        margin: auto;
        margin-left: 15px;
        font-family: Rubik;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 12px;
        color: #3A3A3A;

      }
    }
    >div:last-child{
      display: flex;
      >img{
        width: auto;
        height: 30px;
        margin: auto;
      }
      >span{
        font-size: 14px;
        font-family: rubik;
        text-align: center;
        margin: auto;
        margin-left: 15px;
        font-family: Rubik;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 12px;
        color: #3A3A3A;

      }
    }

  }
  > div: last-child {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    display: flex;
    margin: auto;
  }
`;

const AdminButtons = styled.div`
  width: 100%;
  display: flex;
  height: auto;
  background: ${({ background }) => background ? background : 'green'};
  margin-bottom: 25px;
  cursor: pointer;
  border-radius: 3px;
  padding: 10px 0px;
  >div:first-child{
    width: 15%;
    display: flex;
    >img{
      height: 32px;
      width: auto;
      display: flex;
      margin: auto;
      margin-left: 10px;
    }
  }
  > div: last-child {
    width: 85%;
    display: flex;
    justify-content: center;
    font-family: Rubik-Medium;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
    margin: auto;
    padding-right: 35px;
  }
`;

const CircularBar = styled.div`


.circle-background,
.circle-progress {
  fill: none;
}

.circle-background {
  stroke: #ddd;
}

.circle-progress {
  stroke: #92A4DA;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.circle-text {
  font-size: 3em;
  font-weight: bold;
  fill: black;
}

.points-earned{
  color: white;
  font-size: 16px;
  font-family-rubik;
  fill: white;
}
`;

const ArticleContainer = styled.div`
padding: 20px;
border-radius: 12px;
border: 1px solid #DCDCDC;
background: #FEFEFE;

.title{
  color:#184A61;
font-family: Lato;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 30px;
margin-bottom:20px;
}
.icon-container{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin:20px 0px;
}

.icons{
  display:flex;
  align-items:center;
}

.like-container{
  margin-right:24px;
}

.like-icon{
  margin-right:8px;
  display:flex;
}

.count{
  color: #184A61;
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 18px;
}

.image{
  width:20px;
  height:20px;
}

.row-1{
  display:flex;
  align-items:center;
}

.row-2{
  display:flex;
  align-items:center;
}

.desc{
  color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
}
`

const QuizCard = styled.div`
  margin-bottom: 24px;
`;

const QuestionInput = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const OptionRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 10px;
`;

const OptionLabel = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ active }) => (active ? "#092F41" : "#F8F8F8")};
  color: ${({ active }) => (active ? "#fff" : "#184A61")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
`;

const OptionInput = styled.input`
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const RemoveIcon = styled.span`
  font-size: 20px;
  cursor: pointer;
  color: #da6c74;
`;

const AddOption = styled.div`
  cursor: pointer;
  font-weight: 600;
  margin-top: 6px;
  color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
display:flex;
align-items:center;


.text{
  margin-left:20px;
}

.icon{
padding:0px 8px;
}



.filled-icon{
background:#FCF2F3;
border-radius: 4px;
display: flex;
width: 32px;
height: 32px;
justify-content: center;
align-items: center;
}
`;

const RemoveQuestion = styled.div`
  margin-top: 12px;
  font-size: 14px;
  cursor: pointer;
  color: #999;
`;

const AddQuestion = styled.div`
  margin-bottom: 24px;
  color: #da6c74;
  font-weight: 600;
  cursor: pointer;
`;

const Question =  styled.div`
display:flex;
justify-content:space-between;
width:100%;

.text{
  color: var(--Font-Color-on-Light-theme-500, #184A61);

/* Primary - Lato/Sub Heading */
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; /* 133.333% */
}
`


export {
  Float, Layout, Title, AdventureTitle, ArticleSection, Description, Button, ButtonContainer, ImageContainer, TitleContainer,
  EditButton, ImageContainerIcons, AdminButtons, CircularBar, ArticleContainer, AddQuestion, RemoveQuestion, AddOption, RemoveIcon, OptionInput, OptionLabel, OptionRow, QuestionInput, QuizCard, Question
};
